import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { CommonModule } from '@angular/common';

import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { TranslationSwitchComponent } from '../../../app/components/translation-switch/translation-switch.component';
import { Section, SectionAttributes } from '../../../app/types/section';
import { MainGridComponent } from '@knorr-bremse-portals/ngx-components/components/main-grid';
import { HtmlComponent } from '@knorr-bremse-portals/ngx-components/components/html';
import { SettingsService } from '../../providers/settings.service';
import { combineLatest, map } from 'rxjs';
import { BreadcrumbNavigationComponent } from '@knorr-bremse-portals/ngx-components/components/breadcrumb-navigation';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type PageIntroSection = Section<
  {
    numColumns: 4 | 8 | 12;
    headline?: string;
    date: string;
    abstract: string;
    text: string;
  } & SectionAttributes,
  [
    'numColumns',
    'headline',
    'date',
    'abstract',
    'text',
  ],
  'page-intro'
>;

@Component({
  selector: 'app-page-intro',
  styleUrls: ['./page-intro.component.scss'],
  templateUrl: './page-intro.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule, EditorIdDirective, TranslationSwitchComponent,
    MainGridComponent, HtmlComponent,
    BreadcrumbNavigationComponent,
    FsButtonComponent,
],
})
export class PageIntroComponent extends SectionComponent<PageIntroSection> implements OnInit {

  private settingsService = inject(SettingsService);
  protected breadcrumb$ = combineLatest([
    this.settingsService.navigation,
    this.settingsService.homeUrl.pipe(
      map(url => ({ href: url })),
    ),
  ]).pipe(
    map(([navigation, homeLink]) => ({navigation, homeLink})),
  );

}
